import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function TransporteAnexo21Y22RMF2026ProgramaInformatico() {
  return <CategoryPage category="transporteAnexo21Y22Rmf2026ProgramaInformatico2026" pageTitle="Programa Informatico 2026" />;
}

export default TransporteAnexo21Y22RMF2026ProgramaInformatico;
